import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectLoaded, selectLoading, selectStudents, selectTotalStudents } from '../selectors/students.selector';
import { studentsActions } from '../actions/students.actions';

@Injectable({
    providedIn: 'root',
})
export class StudentsFacade {
    private store = inject(Store);

    // Observable versions
    readonly loaded$ = this.store.select(selectLoaded);
    readonly loadedNonNullable$ = this.store.select(selectLoaded).pipe(filter((student) => student !== null));
    readonly loading$ = this.store.select(selectLoading).pipe(filter((data) => data !== null));
    readonly students$ = this.store.select(selectStudents);
    readonly studentsNonNullable$ = this.store.select(selectStudents).pipe(filter((students) => students !== null));
    readonly totalStudents$ = this.store.select(selectTotalStudents);
    readonly totalStudentsNonNullable$ = this.store.select(selectTotalStudents).pipe(filter((total) => total !== null));

    // Signal versions
    readonly loaded = this.store.selectSignal(selectLoaded);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly students = this.store.selectSignal(selectStudents);
    readonly total = this.store.selectSignal(selectTotalStudents);

    getStudents(page: number, limit: number): void {
        this.store.dispatch(studentsActions.getStudents({ page, limit }));
    }

    clear(): void {
        this.store.dispatch(studentsActions.clear());
    }
}
